import { render } from "./SearchBar.vue?vue&type=template&id=22c6c08c"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/MemberRegistrationReview/components/SearchBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22c6c08c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22c6c08c', __exports__)) {
    api.reload('22c6c08c', __exports__)
  }
  
  module.hot.accept("./SearchBar.vue?vue&type=template&id=22c6c08c", () => {
    api.rerender('22c6c08c', render)
  })

}


export default __exports__